export default {
  en: {
    address: 'Address',

    attachments: 'Attachments',

    attend: {
      title: 'Attending',
    },

    contact: 'Contact',

    snack: {
      generic_error: 'Something went wrong',
    },

    events: {
      participation: 'Participation',
      action: {
        attend: 'I will attend',
        cannot: 'I will not attend',
        withdraw: 'Withdraw',
      },
      participants: {
        title: 'Participants',
        attending: 'Attending',
        not_attending: 'Not attending',
      },
      snack: {
        attend: 'Successfully marked as attending!',
        cannot: 'Successfully marked as not attending!',
        withdraw: 'Successfully withdrew from event!',
      },
    },

    engagement: {
      toggle_true: 'Mark as completed',
      toggle_false: 'Reactivate offer',
    },

    kind: {
      offering: 'Offering',
      looking: 'Looking for',
    },
  },
};
